import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { newsletterReducer } from "components/newsletter-form/state";
import { searchReducer } from "components/site-search/state";
import { searchFilterReducer } from "components/search-filter/state";
import { toolSearchReducer } from "components/tool-search/state";

const reducer = combineReducers({
  newsletter: newsletterReducer,
  search: searchReducer,
  searchFilter: searchFilterReducer,
  toolSearch: toolSearchReducer,
});

const store = configureStore({ reducer });

export { store };
